export type SuccessorRouteCreateContext = {
  createContext?: 'SUCCESSOR_ROUTE';
  predecessorRouteId?: number;
  successorControlTaskId?: number;
  applicationId?: number;
};

export function parseSuccessorRouteCreateSearchParams(
  params: URLSearchParams
): SuccessorRouteCreateContext | undefined {
  if (params.get('createContext') !== 'SUCCESSOR_ROUTE') return undefined;
  const predecessorRouteId = positiveInt(params.get('predecessorRouteId'));
  const successorControlTaskId = positiveInt(params.get('successorControlTaskId'));
  const applicationId = positiveInt(params.get('applicationId'));
  if (predecessorRouteId == null || successorControlTaskId == null) return undefined;
  return {
    createContext: 'SUCCESSOR_ROUTE',
    predecessorRouteId,
    successorControlTaskId,
    ...(applicationId != null ? { applicationId } : {})
  };
}

export function mergeSuccessorContextIntoCreateRouteBody<T extends object>(
  routeBody: T,
  ctx: SuccessorRouteCreateContext | undefined
): T {
  if (
    ctx?.createContext !== 'SUCCESSOR_ROUTE' ||
    ctx.predecessorRouteId == null ||
    ctx.successorControlTaskId == null
  ) {
    return routeBody;
  }
  return {
    ...routeBody,
    createContext: 'SUCCESSOR_ROUTE',
    predecessorRouteId: ctx.predecessorRouteId,
    successorControlTaskId: ctx.successorControlTaskId
  };
}

function positiveInt(raw: string | null): number | undefined {
  if (raw == null || raw === '') return undefined;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.trunc(n) : undefined;
}
